var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useMemo } from 'react';
import { useViewport } from './viewport-provider';
import { useMaxViewport } from './views/max-viewport';
// internal hook to handle both use cases, Viewport components and useViewportMap hook
export var useViewportEntries = function (entries) {
  var _a = useViewport(),
    viewSizes = _a.viewSizes,
    validViewSize = _a.validViewSize;
  var maxViewportSize = useMaxViewport();
  return useMemo(function () {
    var maxSize = maxViewportSize ? viewSizes[maxViewportSize] : Infinity;
    var viewSize = maxSize < validViewSize ? maxSize : validViewSize;
    return entries.reduce(function (result, current) {
      var _a = __read(result, 1),
        resultSize = _a[0];
      var currentSize = viewSizes[current[0]];
      return currentSize <= viewSize && (!resultSize || currentSize > viewSizes[resultSize]) ? current : result;
    }, [null, undefined])[1];
  }, [viewSizes, validViewSize, maxViewportSize, entries]);
};
export var useViewportMap = function (map) {
  return useViewportEntries(useMemo(function () {
    return Object.entries(map);
  }, [map]));
};